import React, { useContext, useEffect, useState } from "react";
import "./stats.css";
import axios from "axios";
import { TextField } from "@material-ui/core";
import { Context } from "../../../context/Context";
const Stats = () => {
  const { token } = useContext(Context);
  const today = new Date().toISOString().substr(0, 10);
  const [date, setDate] = useState(today);
  const [countReservations, setCountReservations] = useState(0);

  const handleChangeDate = (e) => {
    setDate(e.target.value);
  };

  useEffect(() => {
    const getReservations = async () => {
      try {
        const reservations = await axios.get(
          `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/admin/${date}`,
          {
            headers: { authorization: `megaparkingIGHERQHIGQRE ${token}` },
          }
        );
        let lessReservations = reservations.data.filter(
          (r) => r.hasArrived === true
        );
        setCountReservations(lessReservations.length);
      } catch (err) {
        console.log(err);
      }
    };
    getReservations();
  }, [date, token]);

  return (
    <div className="wrapperStats">
      <div className="dataInputStats">
        <TextField
          id="age"
          className="input"
          value={date}
          onChange={handleChangeDate}
          required
          type="date"
          variant="outlined"
          color="secondary"
        />
      </div>
      <div className="header">
        <div className="parkingStats">
          <span>PARKING</span>
        </div>
      </div>
      <div className="stats">
        <div className="imgStats">
          <span>{countReservations}</span>
          <img
            src={`${process.env.PUBLIC_URL}/assets/circle.png`}
            alt="circle"
            className="circleIcon"
          />
        </div>
      </div>
    </div>
  );
};

export default Stats;
